package com.cs.ejobin.vm

import com.cs.ejobin.app.AppSession
import com.cs.ejobin.data.AuthRepository
import com.cs.ejobin.i18n.Keys
import com.cs.ejobin.model.Subscription
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

data class LoginState(
    val email: String = "",
    val password: String = "",
    val isLoading: Boolean = false,
    val errorKey: String? = null
)

class LoginViewModel(
    private val auth: AuthRepository,
    private val session: AppSession
) : BaseViewModel() {

    private val _state = MutableStateFlow(LoginState())
    val state: StateFlow<LoginState> = _state.asStateFlow()

    fun onEmailChange(v: String) { _state.value = _state.value.copy(email = v, errorKey = null) }
    fun onPasswordChange(v: String) { _state.value = _state.value.copy(password = v, errorKey = null) }

    fun login(onSuccess: () -> Unit) {
        val s = _state.value
        if (s.email.trim().isEmpty()) {
            _state.value = s.copy(errorKey = Keys.required_email)
            return
        }

        _state.value = s.copy(isLoading = true, errorKey = null)
        scope.launch {
            runCatching {
                val user = auth.login(s.email.trim(), s.password)
                // Paiement désactivé : on ne récupère plus l’abonnement.
                session.setLoggedIn(user, Subscription.None)
            }.onSuccess {
                _state.value = _state.value.copy(isLoading = false)
                onSuccess()
            }.onFailure {
                _state.value = _state.value.copy(isLoading = false, errorKey = "Erreur de connexion.") // TODO i18n plus tard
            }
        }
    }
}